import { render, staticRenderFns } from "./transferLegal.vue?vue&type=template&id=d21cafd4&scoped=true&"
import script from "./transferLegal.vue?vue&type=script&lang=js&"
export * from "./transferLegal.vue?vue&type=script&lang=js&"
import style0 from "./transferLegal.vue?vue&type=style&index=0&id=d21cafd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21cafd4",
  null
  
)

export default component.exports